import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper, Typography } from '@material-ui/core';
import { hasAtLeastOnePermission, localization } from '../sc-utilities';
import Toolbar from '../sc-utilities/Toolbar';
import { MuiTableRows } from '../../themes';
import * as action from '../np-core/Auth/store/authActions';

const styles = theme => ({
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
});

const ExternalInfoList = props => {
    const { classes, tableColumns, tableActions, externalData, saveColumnsFilter, activeCustomerID, translations, permissions, tableRef } = props;
    const columnObject = useMemo(() => tableColumns
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);
    const selectionPermissions = hasAtLeastOnePermission(permissions, ['unpaired_palette']);

    const [tableOptions, ] = useState({
        filtering: false,
        sorting: false,
        selection: selectionPermissions,
        search: false,
        minBodyHeight: window.innerHeight - 400 < 240 ? 240 : window.innerHeight - 400,
        maxBodyHeight: window.innerHeight - 400,
        pageSizeOptions: externalData.length < 20 ? [externalData.length, 20, 50, 100] : [20, 50, 100],
        exportButton: false,
        exportFileName: 'External info',
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: externalData.length < 20 ? externalData.length : externalData.length < 50 ? 20 : 50,
        emptyRowsWhenPaging: false
    });

    const tableTitle = () => {
        return <div className={classes.tableTitle}>
            <Typography className={classes.typography}>{translations['external_information'] || ' External Information'}</Typography>
        </div>
    };

    const columnHidden = newColumnState => {
        let objToSendColumn = {};
        let objColumns = {};
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden;
            return objColumns;
        })
        objToSendColumn[`ExternalInfo`] = objColumns;
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID });
        return newColumnState;
    }

    return (
        <Paper>
            <MaterialTable
                components={{
                    Toolbar: props => (
                        <Toolbar
                            data={props}
                            actions={tableActions}
                            selectedRows={props.selectedRows}
                            translations={translations}
                        />
                    )
                }}
                localization={localization(translations)}
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={externalData.filter(data => data.ExternalID !== null)}
                options={tableOptions}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </Paper>
    );
}

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
}

const mapDispatchToProps = dispatch => {
    return {
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ExternalInfoList));